import styled from 'styled-components';

const IMDWrapper = styled.div`
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  svg, img {
    height: 100%;
  }
`;

export default {
  IMDWrapper
};